/**
 * Spinner — 공용 로딩 스피너 (tokens.css 의 전역 spin keyframes 사용)
 * ----------------------------------------------------------------------------
 * 역할: Button loading / 인라인 로딩 표시의 단일 구현.
 * 기존 lucide Loader2 + inline animation 재구현(9곳)의 통합 대상 — 이관은 점진(이번 신설만).
 *
 * 사용 예:
 *   <Spinner />                       // 14px, currentColor
 *   <Spinner size={18} />
 */
import React from "react";
import { Loader2 } from "lucide-react";

type Props = {
  size?: number;
  /** 미지정 시 currentColor — 부모 텍스트 색을 따른다 */
  color?: string;
  style?: React.CSSProperties;
};

export default function Spinner({ size = 14, color, style }: Props) {
  return (
    <Loader2
      size={size}
      color={color}
      aria-hidden
      style={{ animation: "spin 0.9s linear infinite", flexShrink: 0, ...style }}
    />
  );
}
